import { useCallback, useContext } from 'react';

import Translation from '../../types/Translation';
import { LanguagesEnum } from '../../types/languages';

import { LocaleProviderContext } from './index';

const useLanguage = () => {
	const { state, dispatch } = useContext(LocaleProviderContext);

	const setLanguage = useCallback((language: LanguagesEnum) => {
		dispatch({
			type: 'set-current-language',
			language,
		});
	}, []);

	const setLocaleContent = useCallback((newContent: Translation) => {
		dispatch({ type: 'set-language-content', content: newContent });
	}, []);

	return {
		currentLanguage: state.current,
		setLanguage,
		setLocaleContent,
	};
};

export default useLanguage;
